import { AuthState } from '../../types';
import { AuthAction, RegistrationActionTypes, SignInActionTypes } from '../type';

const initialState: AuthState = {
  user: { message: '', refreshToken: '', userId: '', name: '', token: '' },
  isAuthorized: false,
  loading: false,
  error: '',
  email: '',
};

export const authReducer = (state = initialState, action: AuthAction): AuthState => {
  switch (action.type) {
    case RegistrationActionTypes.REGISTRATION:
      return {
        ...state,
        loading: true,
        error: '',
        user: { message: '', refreshToken: '', userId: '', name: '', token: '' },
        email: '',
        isAuthorized: false,
      };
    case RegistrationActionTypes.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        user: {
          message: '',
          refreshToken: '',
          userId: action.payload.id,
          name: action.payload.name,
          token: action.payload.email,
        },
        isAuthorized: true,
      };
    case SignInActionTypes.SIGNIN:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case SignInActionTypes.SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
        isAuthorized: true,
        error: '',
      };
    case SignInActionTypes.SIGN_OUT:
      return {
        ...state,
        isAuthorized: false,
        error: '',
      };
    case RegistrationActionTypes.ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case SignInActionTypes.ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
